<template>
<div >
    <p txtNota>Importe suas notas para serem analisadas</p>
    <div class="monitorar">
        <div class="linha">

        </div>
        <div class="linha2" :style="{'width':passo ==2 ?'50%': passo ==3 ?'100%':'0%'}"  >
        </div>
        <div  style="position:relative;">
            <div class="bloco" @click="passo = 1; this.filelist= [];this.exibir = true;scrolB=false;notasValidas = [],totalCofins= 0;totalPis = 0;mensagemErro = ''">            
                <img src="/revisorPisCofins/img/dowloand.svg" alt="">
            </div>    
            <span style="position: absolute; left: 0;right: 0;margin-left: auto;margin-right: auto; width: 49px;"> Enviar </span>
        </div>
        <div  style="position:relative;">
            <div class="bloco" :style="{'border':passo >=2 ?'3px solid #AF3437': '#E1E1E1'}"  @click="passo = 2;scrolB= true;notasValidas = [],totalCofins= 0;totalPis = 0;exibirNotaVazia = false;mensagemErro = ''">               
                    <img src="/revisorPisCofins/img/selecionarNota.svg" alt="" v-if="passo >=2">
                    <img src="/revisorPisCofins/img/selecionarNotaBranco.svg" alt="" v-else>
            </div>
            <div style="position: absolute;left: 0;right: 0;margin-left: auto;margin-right: auto; width: 50px;"> Revisar</div>
        </div>
        <div style="position:relative;">
            <div class="bloco" :style="{'border':passo >=3 ?'3px solid #AF3437': '#E1E1E1'}" @click="passo = 3">
                <img src="/revisorPisCofins/img/concluido.svg" alt="" v-if="passo >=3">
                <img src="/revisorPisCofins/img/concluidoBranco.svg" alt="" v-else>
            </div>
            <span  style="position: absolute;left: 0;right: 0;margin-left: auto;margin-right: auto; width: 70px; ">Concluido</span>
        </div>
    </div>
    <div v-if="passo <=2" class="atePassoDois" >
        <label for="assetsFieldHandle" style="display: flex; align-items: center; justify-content: center; background: rgb(175, 52, 55); cursor: pointer; width: 100%; height: 40px; border-radius: 2px; margin: 60px 0px 25px;"><p style="font-size: 16px; margin: 0px; color: rgb(255, 255, 255);font-weight:600;"><img src="/revisorPisCofins/img/dowloandBranco.svg" alt="" style="margin-right:10px;"> Clique aqui para selecionar os arquivos .ZIP ou .XML</p></label>
        <input type="file" multiple name="fields[assetsFieldHandle][]" id="assetsFieldHandle" style="display: none;" class="w-px h-px opacity-0 overflow-hidden absolute" @change="onChange" ref="file" accept=".zip,.xml" />
        <div class="flex w-full h-screen items-center justify-center text-center">
        <p class="NotasEncontradas" v-if="passo == 2">Notas Encontradas</p>
        
        <div :class="{scrolA:true,scrolB:scrolB }" @dragover="dragover" @dragleave="dragleave" @drop="drop" >
            <div class="backgroundOptante" v-if="passo == 2 && respostaOp">
                <div class="ajustarOp">
                        <p>A empresa emissora das notas é optante pelo Simples Nacional?  </p>
                        <button style="margin: 0px 10px;width:50px;font-size:15px;" @click="finalizar(true)">Sim</button>
                        <button @click="finalizar(false)" style="width:50px;font-size:15px;">Não</button>
                </div>
            </div>
            <div class="revisandoNotas" :style="{'top': spiner ? '0px': '-40px'}">
                Revisando Notas                
            </div>
            <progress class="pure-material-progress-linear" :style="{'width':'100%', 'position': 'absolute', 'top': spiner ? '35px': '-35px','z-index':'2'}"/>
            <label for="assetsFieldHandle" class="block cursor-pointer" style=" width: 100%;height: 100%;" v-if="filelist.length ==0">
                <div style="color: #7e7e7e;cursor: pointer;font-size: 16px;font-weight: 400;width: 100%;display: flex;height: 100%;align-items: center; justify-content: center;" >
                    <span style="padding:60px;" >Se preferir, arraste aqui os seus arquivos .ZIP e .XML  </span>            
                </div>
            </label>          
            <ul  v-cloak  class="ulDentro" >
                <li class="text-sm p-1" v-for="(file,i) in filelist" :key="i" style="display: flex;align-items: center;justify-content: space-between;" @click="remove(i)">
                    <div>{{file.name }}</div>
                    <a style="color:#0d6efd;cursor: pointer;padding-right: 15px;">Excluir</a>
                </li>
            </ul>
        </div>
        </div>
        <div style="display:flex;justify-content: center;">
            <button class="btnRed" style="width:115px;height:37px;margin-top:30px;" @click="isOptante" v-if="passo == 2"> Revisar </button>
            <button  class="btnCancelar" style="width:115px;height:37px;margin-top:30px;" @click="cancelar(1);notasValidas = [],totalCofins= 0;totalPis = 0;exibirNotaVazia = false;mensagemErro = ''" v-if="passo == 2"> Cancelar </button>
        </div>
    </div>
    <div v-else>        
        <div class="pesquisar"  v-show="!exibirNotaVazia">
            <div class="p">
                <div>
                    {{atualPesquisar}} <img src="/revisorPisCofins/img/setaBaixo.svg" alt="" style="width: 15px;">
                </div>
                <div class="op">
                    <p @click="atualPesquisar = 'NFe/NFCe'">Chave NFe/NFCe</p>
                    <p @click="atualPesquisar = 'Destinatário'">Destinatário</p>
                    <p @click="atualPesquisar = 'Produto'">Produto</p>
                    <p @click="atualPesquisar = 'NCM'">NCM</p>
                </div>
            </div>    
            <div class="barra">
                <img src="/revisorPisCofins/img/pesquisar.svg" alt="" style="width: 20px;">
                <input type="text" v-model="txtPes" placeholder="Pesquisar">
            </div>
        </div>  

        <div class="resultado-anos">
            <div :class="{'resultado-ano' :true, 'ano-toggle':menorAno == n}" v-for="(n,i) in anos" :key="i" @click="trocaAno(n)">
                {{ n }}
            </div>
        </div>
        <div style="    display: flex;   justify-content: flex-end;    margin-bottom: 11px;" class="imprimi">
            <img src="https://www.lefisc.com.br/revisorPisCofins/img/print.svg" alt="" width="45" style="cursor:pointer" @click="tirarPrint()"> 
        </div> 
        <div v-show="!exibirNotaVazia"> 
            <div class="resultado-notas">    
                              
                <div  v-for="(n,i) in novoObjeto[menorAno]" :key="i" v-show="n != null" style="width: 100%; max-width: 250px;" @click="trocaMes(i)">
                    <div :class="{mes:true,'mes-toggle':this.mesSelecionado == i}">
                        {{meses[i-1]}}
                    </div>
                </div>
            </div>            
           <TableResultado :optante="optante" :dados="ListaA" :totalPisA="totalPis" :totalCofinsA="totalCofins" :texto="txtPes" :atualPesquisar="atualPesquisar"/>
        <div class="produtos">
            <div class="produtos-resultado">
                <div style="border: 1px solid #393842;">
                    <p> Produtos  Monofásicos: {{ListaA.filter(e=> e.revisao == 1).length}}</p>
                    <p>Valor Total:  {{totalMono}}</p>
                </div>
                <div  style="border: 1px solid rgb(65, 130, 206);">
                    <p> Produtos  Alíquota Zero: {{ListaA.filter(e=> e.revisao == 2).length}}</p>
                    <p>Valor Total:  {{totalAliZero}}</p>
                </div>
                <div style="border: 1px solid #10b5cf;">
                    <p>Produtos Subst. Tributária: {{ListaA.filter(e=> e.revisao == 3).length}} </p>
                    <p>Valor Total:  {{totalSub}}</p>
                </div>
                <div >             
                   <p>Valor total dos produtos: </p>
                   <p> {{totalNota}}</p>
                </div>
               
            </div>
            
        </div>
        </div>
        <div v-if="exibirNotaVazia" class="nenhumNota">
            {{ mensagemErro || 'Não encontramos produtos que necessitam ser revisados nas notas enviadas.' }}
        </div>
    </div>
   <div style="display:flex;align-items: center;justify-content: center;">
        <button class="btnRed" style="width:180px;height:37px;margin-top:30px;" @click="cancelar(1);notasValidas = [],totalCofins= 0;totalPis = 0;exibirNotaVazia = false;mensagemErro = ''" v-if="passo == 3"> Reenviar arquivos </button>
    </div>
</div>
</template>

<script>
import TableResultado from '../components/TableResultado.vue'
import axios from 'axios'
export default {    
    components:{
        TableResultado
    },
    data(){
        return{
            meses:['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
            totalNota:0,
            totalMono:0,
            totalAliZero:0,
            totalSub:0,
            invalida:0,
            valida:0,
            txtPes:'',
            atualPesquisar:'Selecionar',
            passo:0,
            filelist:[],
            spiner:false,         
            scrolB:false,            
            notasInvalidas:[],
            sairForaDois:false,
            respostaOp:false,
            notasValidas:[],
            totalPis:0,
            totalCofins:0,     
            exibirNotaVazia:false,
            mensagemErro:'',
            optante:false,   
            menorAno:'',
            mesSelecionado:0,
            anos:[],
            novoObjeto:[]

        }
    },
     computed:{
        ListaA(){          
            if(this.atualPesquisar == 'NCM'){            
                return this.notasValidas.filter(e=> e.ncm.includes(this.txtPes))   
            }else if(this.atualPesquisar == 'NFe/NFCe'){                
                return this.notasValidas.filter(e=> e.chave.includes(this.txtPes)) 
            } else if(this.atualPesquisar == 'Destinatário')  {              
                return this.notasValidas.filter(e=> e.dest.toLowerCase().includes(this.txtPes.toLowerCase()))   
            } else if(this.atualPesquisar == 'Produto'){              
                return this.notasValidas.filter(e=> e.produto.toLowerCase().includes(this.txtPes.toLowerCase()))   
            }        
            return  this.notasValidas          
        },
    },
    methods:{
        trocaAno(index){
            this.menorAno = index           
            for(let i =0; i<this.meses.length;i++){           
                if( this.novoObjeto[this.menorAno][i] !=  undefined){
                    this.mesSelecionado = i;                  
                    this.notasValidas = this.novoObjeto[this.menorAno][`${this.mesSelecionado}`]
                    break;
                }
            }
            this.totalCofins = 0;
                this.totalPis = 0;
                if(this.notasValidas.length != 0){
                        this.notasValidas.forEach(e=>{                                                                       
                             if(e.pis != null & e.pis != ''){                                
                                this.totalPis = this.totalPis + parseFloat(e.pis)
                            }                            
                            if(e.cofins != null & e.pis != ''){
                                this.totalCofins = this.totalCofins + parseFloat(e.cofins)
                            }                  
                        })                          
                }
          
        },
        trocaMes(index){
            this.mesSelecionado = index
            this.notasValidas = this.novoObjeto[this.menorAno][`${this.mesSelecionado}`]
            this.totalNota = this.totalMono+this.totalAliZero+this.totalSub
            this.totalCofins = 0;
                this.totalPis = 0;
                if(this.notasValidas.length != 0){
                        this.notasValidas.forEach(e=>{                                                                       
                             if(e.pis != null & e.pis != ''){                                
                                this.totalPis = this.totalPis + parseFloat(e.pis)
                            }                            
                            if(e.cofins != null & e.pis != ''){
                                this.totalCofins = this.totalCofins + parseFloat(e.cofins)
                            }                  
                        })                          
                }
                         
        },
    tirarPrint(){
        var html = '';
    
    for(let a of  this.ListaA){
      let pis = (a.pis != null && a.pis !== '') ? parseFloat(a.pis).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 'R$ 0,00'
      let cofins = (a.cofins != null && a.cofins !== '') ? parseFloat(a.cofins).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 'R$ 0,00'
      html =   html + `
        <tr style="font-size:13px;">
          <td>${a.chave}</td>
          <td>${a.dest}</td>
          <td>${a.produto}</td>
          <td>${a.ncm}</td>
          <td>${a.extipi == null ? '' : a.extipi}</td>
          <td>${a.revisao == 1 ? 'Monofásico'  :  a.revisao == 2 ? 'Alíquota Zero' : 'Subst. tributária'}</td>          
          <td>${a.cfop}</td>
          <td>${pis}</td>
          <td>${cofins}</td>
        </tr>
        ${

            a.obs != '' ? `<td colspan="8" styke="font-weight:bold;background: rgb(255, 170, 33);">${a.obs}</td>` : ''
        }
        <tr >          
        </tr>
          `
    }
        var tela_impressao = window.open('about:blank');
        tela_impressao.document.write(`<!DOCTYPE html>
        <head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Resultado</title>
    <style>        
            
    
                .produtos{
    width: 100%;
    margin-top: 20px;
    padding:5px;
   
    border-radius: 5px;
    
}

.produtos .produtos-resultado{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;  
    border-radius: 5px;
    background: #EEEEEE;
    border-radius: 5px;
    font-size: 12px;
    color: #393842;
    
}
.produtos .produtos-resultado div{
   display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: 10px;
    height: 80px;
    color: #393842;
    border-right: 1px solid #fff;
    width: 100%;
    margin: 5px;
    border-radius: 3px;
}
.produtos div p{
    margin-bottom: 5px;
    font-size: 14px;
    font-weight: 700;
}
</style>
            
            </head>
        <body style="font-size:14px;max-width:1200px;">
            <table border="1px solid #000;">
        <tr style="font-size:13px;">
            <td>Chave NFe/NFCe</td>
            <td>Destinatário</td>
            <td>Produto</td>
            <td>NCM</td>
            <td>EXTIPI</td>
            <td>Revisão</td>
            <td>CFOP</td>
            <td>PIS</td>
            <td>Cofins</td>
        </tr>
       ${html}   
    </table>
    <p> Total Pis: ${this.totalPis.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}</p>
    <p> Total Cofins:  ${this.totalCofins.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}</p>

    <div class="produtos">
            <div class="produtos-resultado">
                <div style="border: 1px solid #000;margin-top:10px;padding:10px;">
                    <p> Produtos  Monofásicos: ${this.ListaA.filter(e=> e.revisao == 1).length}</p>
                    <p>Valor Total:  ${this.totalMono}</p>
                </div>
                <div style="border: 1px solid #000;margin-top:10px;padding:10px;">
                    <p> Produtos  Alíquota Zero: ${this.ListaA.filter(e=> e.revisao == 2).length}</p>
                    <p>Valor Total:  ${this.totalAliZero}</p>
                </div>
                <div style="border: 1px solid #000;margin-top:10px;padding:10px;">
                    <p>Produtos Subst. Tributária: ${this.ListaA.filter(e=> e.revisao == 3).length} </p>
                    <p>Valor Total:  ${this.totalSub}</p>
                </div>
                <div >             
                   <p>Valor total dos produtos: </p>
                   <p> ${this.totalNota}</p>
                </div>
                <div >
                   <p>Produtos válidos:  ${this.validas}</p>
                   <p>Produtos inválidos:  ${this.invalidas}</p>
                   <p>Total de produtos: ${this.validas+this.invalidas}</p>                  
                </div>
            </div>
            
        </div>
        </body>
        </html>
        `)
        tela_impressao.print()

    },
    isOptante(){
        this.respostaOp = true 
        let scrolA = document.querySelector('.scrolA')       
        scrolA.scrollTo(0,0)
        scrolA.style.overflowY = 'hidden'
    },
    async finalizar(optante){
        this.totalPis = 0;
        this.totalCofins = 0
         optante
        this.notas = []
        this.spiner = true
        this.respostaOp = false
        let scrolA = document.querySelector('.scrolA') 
        scrolA.style.overflowY = 'auto'
        try{
            let formXml = new FormData()       
            let files = []  
            this.filelist.forEach(e=>{
                files.push(e)
                formXml.append(`files`,e)
            })  
            if(optante){
                optante = 1
                this.optante =  true
            }else{
                optante = 2
                this.optante =  false
            }
            formXml.append('optante',optante)      
            await axios.post(`https://www.lefisc.com.br/api/revisor/`,formXml)
            .then(result=>{  
                  this.totalMono = 0    
                   this.totalAliZero = 0  
                   this.totalSub= 0    
                if(result.data.lista.length != 0){
                    this.validas =       result.data.validas
                    this.invalidas =     result.data.invalidas     
                    this.notasValidas =  result.data.lista 
                    this.notasValidas.sort(this.compare)
                    const novoObjeto = {};
                console.log('vindo')
                for (let i = 0; i <  this.notasValidas.length; i++) {
                    let data =  new Date(this.notasValidas[i].emissao);
                
                    let ano = data.getFullYear();
                    let mes = data.getMonth() + 1;

                    if (!novoObjeto[ano]) {
                        novoObjeto[ano] = [];
                        this.anos.push(ano)
                    }

                    if (!novoObjeto[ano][mes]) {
                        novoObjeto[ano][mes] = [];
                    }

                    novoObjeto[ano][mes].push(this.notasValidas[i]);
                    }
                    
                    let menor = this.encontrarMenorNumero(this.anos)
                    this.menorAno = menor
                    this.novoObjeto = novoObjeto
                    for(let i =0; i<=this.meses.length;i++){           
                        if( this.novoObjeto[this.menorAno][i] !=  undefined){
                            this.mesSelecionado = i; 
                            break;  
                        }
                    }
                    if(this.notasValidas.length != 0){
                        this.notasValidas.forEach(e=>{    
                        if(e.revisao == 1){
                            this.totalMono = this.totalMono + parseFloat(e.valor)
                        }else if(e.revisao == 2){
                            this.totalAliZero = this.totalAliZero + parseFloat(e.valor)
                        }else if(e.revisao == 3){
                            this.totalSub = this.totalSub + parseFloat(e.valor)
                        }
                            e.ncm = e.ncm.replace(/(\d{4})(\d{2})/, '$1.$2.')  
                        })                          
                    }else{
                        this.exibirNotaVazia= true
                    }
                }else{
                    this.exibirNotaVazia= true
                }            
                this.passo = 3
                this.totalNota = this.totalMono+this.totalAliZero+this.totalSub
                this.totalSub = this.totalSub.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
                this.totalAliZero = this.totalAliZero.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
                this.totalMono = this.totalMono.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
                this.totalNota =  this.totalNota.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
                console.log(this.menorAno,this.mesSelecionado)
                this.notasValidas = this.novoObjeto[this.menorAno][`${this.mesSelecionado}`]              
                    this.totalCofins = 0;
                this.totalPis = 0;
                if(this.notasValidas.length != 0){
                        this.notasValidas.forEach(e=>{                                                                       
                             if(e.pis != null & e.pis != ''){                                
                                this.totalPis = this.totalPis + parseFloat(e.pis)
                            }                            
                            if(e.cofins != null & e.pis != ''){
                                this.totalCofins = this.totalCofins + parseFloat(e.cofins)
                            }                  
                        })                          
                }
                
                this.cancelar(3)               
            }).catch(err=>{
                this.totalPis = 0;
                this.totalCofins = 0
                this.notas = []  
                
                // Tratamento específico para erro 422
                if(err.response && err.response.status === 422){
                    this.mensagemErro = err.response.data.msg || 'Nenhuma nota com necessidade de revisão'
                    this.exibirNotaVazia = true
                    this.passo = 3
                    this.cancelar(3)
                } else if(err.response && err.response.data && err.response.data.msg){
                    // Outros erros com mensagem
                    this.mensagemErro = err.response.data.msg
                    this.exibirNotaVazia = true
                    this.passo = 3
                    this.cancelar(3)
                } else {
                    // Erro genérico
                    this.mensagemErro = 'Nenhuma nota com necessidade de revisão'
                    this.exibirNotaVazia = true
                    this.passo = 3
                    this.cancelar(3)
                }                
            })  
        }catch(e){
          this.cancelar(1)
        }
    },
    encontrarMenorNumero(array) {
  let menorNumero = array[0]; // inicializa a variável com um valor muito grande

  for (let i = 0; i < array.length; i++) {
    if (array[i] > menorNumero) {
      menorNumero = array[i];
    }
  }

  return menorNumero;
},
    onChange() {    
        console.log(this.$refs.file.files)
        this.scrolB = true
        this.filelist = [...this.$refs.file.files];       
        this.passo = 2   
    },
    remove(i) {
      this.filelist.splice(i, 1);
      if(this.filelist.length ==0){         
          this.passo = 1;
          this.scrolB = false
      }
    },
    cancelar(passo){
        this.spiner = false
        this.passo =passo
        this.scrolB = false
        this.filelist = []
        this.notas = []
    },
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains('bg-green-300')) {
        event.currentTarget.classList.remove('bg-gray-100');
        event.currentTarget.classList.add('bg-green-300');
      }
    },
    dragleave(event) { 
      event.currentTarget.classList.add('bg-gray-100');
      event.currentTarget.classList.remove('bg-green-300');
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); 
      event.currentTarget.classList.add('bg-gray-100');
      event.currentTarget.classList.remove('bg-green-300');
    },
    compare(a,b) {
  if (a.ncm < b.ncm)
     return -1;
  if (a.ncm > b.ncm)
    return 1;
  return 0;
}
    },  
    async mounted(){  
        if(this.$route.params.isConsulta != 'revisar'){
            this.passo = 3
            this.optante = this.$store.state.optante
            await axios.post(`https://www.lefisc.com.br/api/revisor/cliente/caminho`,
            {"idConsulta":this.$route.params.isConsulta})
            .then(result=>{    
                this.validas =     result.data.validas
                this.invalidas =     result.data.invalidas      
                this.notasValidas = result.data.lista
                this.notasValidas.sort(this.compare)
                const novoObjeto = {};
                
                for (let i = 0; i <  this.notasValidas.length; i++) {
                    let data =  new Date(this.notasValidas[i].emissao);
                
                    let ano = data.getFullYear();
                    let mes = data.getMonth() + 1;

                    if (!novoObjeto[ano]) {
                        novoObjeto[ano] = [];
                        this.anos.push(ano)
                    }

                    if (!novoObjeto[ano][mes]) {
                        novoObjeto[ano][mes] = [];
                    }

                    novoObjeto[ano][mes].push(this.notasValidas[i]);
                    }
                    
                    let menor = this.encontrarMenorNumero(this.anos)
                    this.menorAno = menor
                    this.novoObjeto = novoObjeto
                 
                    for(let i =0; i<=this.meses.length;i++){  
                        console.log(this.novoObjeto[this.menorAno][i])         
                    if( this.novoObjeto[this.menorAno][i] !=  undefined){
                        this.mesSelecionado = i;   
                        break;
                    }
            }
                 this.notasValidas.forEach(e=>{
                    console.log(this.notasValidas)
                             if(e.revisao == 1){
                            this.totalMono = this.totalMono + parseFloat(e.valor)
                        }else if(e.revisao == 2){
                            this.totalAliZero = this.totalAliZero + parseFloat(e.valor)
                        }else if(e.revisao == 3){
                            this.totalSub = this.totalSub + parseFloat(e.valor)
                        }
                    e.ncm = e.ncm.replace(/(\d{4})(\d{2})/, '$1.$2.')                                                 
                    })
                    this.totalNota = this.totalMono+this.totalAliZero+this.totalSub
                    this.totalSub = this.totalSub.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
                this.totalAliZero = this.totalAliZero.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
                this.totalMono = this.totalMono.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
                this.totalNota =  this.totalNota.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
                console.log('-------------------------')
                console.log(this.novoObjeto,this.mesSelecionado,this.menorAno)
                this.notasValidas = this.novoObjeto[this.menorAno][`${this.mesSelecionado}`]

                console.log(this.notasValidas)
                this.totalCofins = 0;
                this.totalPis = 0;
                if(this.notasValidas.length != 0){
                        this.notasValidas.forEach(e=>{                                                                       
                             if(e.pis != null & e.pis != ''){                                
                                this.totalPis = this.totalPis + parseFloat(e.pis)
                            }                            
                            if(e.cofins != null & e.pis != ''){
                                this.totalCofins = this.totalCofins + parseFloat(e.cofins)
                            }                  
                        })                          
                }
                   
            })
        }
       
    }  
}
</script>

<style>
.resultado-notas, .resultado-notas .mes {
    width: 100%;
    display: flex;
}
.mes-toggle {
    background: #af3437!important;
    color: #fff!important;
}
.resultado-notas .mes {
    max-width: 250px;
    cursor: pointer;
    height: 36px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background: #fff;
    color: #af3437;
    border: 2px solid #af3437;
    border-radius: 10px 10px 0 0;
    font-weight: 700;
    font-size: 14px;
}
.resultado-anos{  
    display: flex;  
    justify-content: space-around;    
    align-items: center;
}
.resultado-ano {
    cursor: pointer;
    margin: 0 10px;
    text-align: center;
    max-width: 155px;
    width: 100%;
    height: 50px;
    border: 4px solid #af3437;
    border-radius: 7px;
    font-size: 25px;
    font-weight: 700;
    color: #212529;
}
.ano-toggle {
    background: #af3437;
    color: #fff!important;
}
@media print {
    
    .imprimi{
        display: none !important;
    }
    body{
        background:#fff !important;
    }
    #app{
        min-height: 300px !important;
    }    
    .monitorar{
    display: none !important;
}
.atualheader{
    display: none !important;
}
.opcoess{
    display: none !important;
}
.btnRed{
    display: none !important;
}
.atualheader{
    display: none !important;
}
[txtNota]{
    display: 
    none !important;
}
#navba{
display: none !important;
}
body > div:nth-child(3){
    display: none!important;
}
.pesquisar{
    display: none !important;
}
}
.produtos{
    width: 100%;
    margin-top: 20px;
    padding:5px;
    border: 1px solid rgb(175, 52, 55);
    border-radius: 5px;
}

.produtos .produtos-resultado{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;  
    border-radius: 5px;
    background: #EEEEEE;
    border-radius: 5px;
    font-size: 12px;
    color: #393842;
    
}
.produtos .produtos-resultado div{
   display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: 10px;
    height: 80px;
    color: #393842;
    border-right: 1px solid #fff;
    width: 100%;
    margin: 5px;
    border-radius: 3px;
}
.produtos div p{
    margin-bottom: 5px;
    font-size: 14px;
    font-weight: 700;
}
.nenhumNota{
    background: #F4DDDE;
    border: 1px solid #AF3437;
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 120px;
    font-size: 17px;
}
.ronaldo{
    border: 1px solid rgb(175, 52, 55);
    padding: 5px;
    box-shadow: rgb(0 0 0 / 25%) 0px 4px 4px;
    background: #fff;   
}
.footer-resultado{
    padding-right: 5px;
    padding-left: 5px;
    border: 1px solid rgb(175, 52, 55);
    display: flex;
    border-top: 0;
    
    background: #AF3437;
    color: #FAF8FA;
    font-weight: bold;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-bottom: 0;
     font-size: 12px;
}
.header-resultado{
    padding-right: 5px;
    padding-left: 5px;
    border: 1px solid rgb(175, 52, 55);
    display: flex;
    border-top: 0;
    
    background: #AF3437;
    color: #FAF8FA;
    font-weight: bold;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom: 0;
}
.body-resultado{
    display: flex;
    cursor: pointer;
    background: #EEEEEE;;
    border-radius: 5px;  
    font-size: 12px;
    color:#393842;  
     border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
}
.metade{     
    width: 100%;
    padding: 15px 10px;
    border-right:1px solid #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}
.pesquisar{
        display: flex;
    margin-bottom: 40px;
}
.pesquisar .barra input{
    width: 100%;
    background: #fff0;
    position: absolute;
    left: 0;
    padding-left: 40px;
    border: none;
}
.pesquisar .barra input:focus{
    outline: none;
}
.pesquisar .op{
    display: none;
       left: 0;
    width: 180px;
    position: absolute;
    background: #fff;
    box-shadow: 0px 8px 16px 0px rgb(0 0 0 / 20%);
    z-index: 1;
    color: #AF3437;
    padding: 10px;
    top: 35px;
}
.pesquisar .op p{
    margin-bottom: 0;
    height: 35px;
}
.pesquisar .p:hover .op{
display: initial;
}
.pesquisar .p{
    position: relative;
        background: #AF3437;
    border: 1px solid #AF3437;
    box-sizing: border-box;
    border-radius: 5px 0px 0px 5px;
    color: #fff;
    font-weight: 600;
    padding: 6px;
    width: 180px;
    cursor: pointer;
}
.pesquisar .barra{
    position: relative;
    background: #FFFFFF;
    border: 1px solid #AF3437;
    box-sizing: border-box;
    border-radius: 0px 5px 5px 0px;
    width: 100%;
        display: flex;
    align-items: center;
    padding-left: 15px;
}
.backgroundOptante{
    position: absolute;
    top: 0px;
    width: 100%;
    height: 100%;
    background: #565555b0;
    font-size: 14px;
    z-index: 2;
}
.ajustarOp p{
       margin-bottom: 0;
    color: #000;
    font-weight: bold;
}
.ajustarOp button{
        background: #AF3437;
    border-radius: 5px;
    border: none;
    color: #fff;
 
}
.ajustarOp{
    display: flex;
    color: #fff;
    font-size: bold;
    height: 40px;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding-left: 15px;
    background: #FFC038;
    transition: 0.5s all;
}
.atePassoDois{
    position:relative;z-index:2;transition: 0.5s all;
    left: 0%;
}
.pure-material-progress-linear {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: none;
    height: 0.25em;
    color: rgb(175, 52, 55);
  
    font-size: 16px;
}

.pure-material-progress-linear::-webkit-progress-bar {
    background-color: transparent;
}

/* Determinate */
.pure-material-progress-linear::-webkit-progress-value {
    background-color: rgb(175, 52, 55);
    transition: all 0.2s;
}

.pure-material-progress-linear::-moz-progress-bar {
    background-color: rgb(175, 52, 55);
    transition: all 0.2s;
}

.pure-material-progress-linear::-ms-fill {
    border: none;
    background-color: rgb(175, 52, 55);
    transition: all 0.2s;
}

/* Indeterminate */
.pure-material-progress-linear:indeterminate {
    background-size: 200% 100%;
    background-image: linear-gradient(to right, transparent 50%, currentColor 50%, currentColor 60%, transparent 60%, transparent 71.5%, currentColor 71.5%, currentColor 84%, transparent 84%);
    animation: pure-material-progress-linear 2s infinite linear;
}

.pure-material-progress-linear:indeterminate::-moz-progress-bar {
    background-color: transparent;
}

.pure-material-progress-linear:indeterminate::-ms-fill {
    animation-name: none;
}

@keyframes pure-material-progress-linear {
    0% {
        background-size: 200% 100%;
        background-position: left -31.25% top 0%;
    }
    50% {
        background-size: 800% 100%;
        background-position: left -49% top 0%;
    }
    100% {
        background-size: 400% 100%;
        background-position: left -102% top 0%;
    }
}

.revisandoNotas{
    position: absolute;
    background: #F4DDDE;
    font-weight: bold;
    height: 40px;
    z-index: 2;
    transition: 0.5s all;
    width: 100%;
    display: flex;
    align-items: center;
    padding-left: 15px;
}
.btnCancelar{
    width: 115px;
    height: 37px;
    margin-top: 30px;
    border: 1px solid #AF3437;
    border-radius: 5px;
    color: #AF3437;
    background: #fff;
    font-weight: 600;
    margin-left: 20px;
}
div.scrolB{
    border: 2px solid #AF3437;
    border-top-left-radius: 0px !important;
    border-top-right-radius: 0px !important;
}
.NotasEncontradas{
    background: rgb(175, 52, 55);
    cursor: pointer;
    width: 100%;
    height: 40px;
    margin-bottom: 0;
    display: flex;
    color: #fff;
    font-weight: bold;
    padding-left: 15px;
    align-items: center;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}
.scrolA::-webkit-scrollbar {
  width: 8px !important; 
}
.scrolA::-webkit-scrollbar-track {
  background-color: rgb(0, 0, 0, 0);
}
.scrolA::-webkit-scrollbar-thumb {
  background: #4e4e4e;
  border-radius: 25px;
}
.scrolA{
    position: relative;
border: 2px dashed #AF3437;
    box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
    max-height:400px;overflow:auto;flex-direction: column;display: flex;border-radius: 8px;align-items:center;justify-content: center;
}
.ulDentro{
    padding: 0;
    display: flex;
    width: 100%;
    justify-content: center;
    flex-direction: column;
    align-items: center;     
    margin-bottom: 5px; 
}
.monitorar{
    display: flex;
    position: relative;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 100px;
    margin-top:70px;
}
.linha{
 border:none;
  border-top:2px dashed #8F8F8F;
  color:#fff;
  background-color:#fff;
  height:1px;
  width:100%;
  position: absolute;

}
.linha2{
    width: 0%;
    height: 1px;
    border-top:2px dashed #AF3437;
    background: #AF3437;
    position: absolute;
    z-index: 2;
    transition: 0.5s all;
}
.monitorar .bloco{
        border: 3px solid #AF3437;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #E1E1E1;
    position: relative;
    z-index: 2;
}
[txtNota]{
    color:#AF3437;
    font-size: 22px;
    border-bottom:2px solid #AF3437;
    font-weight: bold;
    padding-bottom: 5px;
    margin-bottom: 50px;
}

li.text-sm.p-1 {
    font-size: 13px;
    width: 99.5%;
    list-style: none;
    background: #EEEEEE;
    display: flex;
    padding: 23px;
    height: 40px;
    border-radius: 5px;
    margin-top:5px;
    display: flex;
    padding-left: 20px;
    align-items: center;
    padding-left: 15px !important;
}
label {
    color: #7e7e7e;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
}
li{
    color: #3e3e3e;
}
li  button{
    color: #1696e7;
    outline: medium none;
    background: #fff;
}
.nota {
    width: 100%;
    background: #fff3cd;
    border: 1px solid #ffeeba;
    margin: 15px 0;  
}
.nota p {
    margin: 0!important;
    font-size: 15px!important;
    color: #212529!important;
    padding: 10px;
    font-weight: 700!important;
    text-align: justify;
}
.blocos{
    display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
}

.radio-component>input:active+label>.input-box, .radio-component>input:checked+label>.input-box, .radio-component>input:focus+label>.input-box {
    background: #af3437!important;
    background-image: none!important;
    -webkit-box-shadow: none!important;
    box-shadow: none!important;
}
.large-bar-radio {
    margin: 0 0 0 20px;
}
.radio-component>input {
    opacity: 0;
    position: absolute;
}
.radio-component>input:checked+label>.input-box>.input-box-circle {
    opacity: 1;
    margin: 22%;
    width: 56%;
    height: 56%;
}
label{
    margin-bottom: 0px;
}
.radio-component>input+label>.input-box>.input-box-circle {
    display: block;
    margin: 50%;
    width: 0;
    height: 0%;
    background: #fff;
    border-radius: 50%;
    opacity: 0;
    transition: width .15s ease-in,height .15s ease-in,margin .15s ease-in;
}
.radio-component>input+label>.input-box {
    display: inline-block;
    border: 1px solid #000;
    border-radius: 50%;
    margin: 0;
    padding: 0;
    width: 1em;
    height: 1em;
    background: #fff;
    overflow: hidden;
    vertical-align: -5%;
    user-select: none;
}

.radio-component>input+label>.input-box {
    border-color: #af3437!important;
    background: #fff!important;
}
.large-bar p{
font-size: 14px;
 margin: 0px 0px 0px 20px; 
 font-weight: 700; 
 color: rgb(56, 56, 56); 
 line-height: 15px;
}
.blocos{
    display: flex;   
    justify-content: center;
}
.large-bar {    
    display: flex;
    align-items: center;  
    justify-content: flex-start;
    min-height: 70px!important;
    max-height: 300px!important;
    height: 100px!important;
    background: #eee;
    max-width: 600px;
    width: 100%;
    border-radius: 5px;   
    transition: all .2s;
    border-left: 10px solid #af3437;
}
</style>